import { useCallback } from 'react';
import { columnSlice } from './columnStore';
import { useFastDispatch } from '../../context/FastContext';
export const useSetAggregations = () => {
  const dispatch = useFastDispatch();
  return useCallback(aggs => {
    dispatch(columnSlice.actions.setAggregations(aggs));
  }, [dispatch]);
};